// Product page orchestrator: wires TGLProduct modules for sections with product markup.

(function () {
  const TGLProduct = (window.TGLProduct = window.TGLProduct || {});
  const SELECTORS = TGLProduct.SELECTORS;

  function applyVariant(ctx, variant) {
    if (!variant) return;
    if (ctx.variantIdInput) {
      ctx.variantIdInput.value = variant.id;
    }

    if (typeof TGLProduct.updateGallery === "function") {
      TGLProduct.updateGallery(ctx, variant);
    }
    if (typeof TGLProduct.updateModelInfo === "function") {
      TGLProduct.updateModelInfo(ctx, variant.id);
    }
    if (typeof TGLProduct.updateStock === "function") {
      TGLProduct.updateStock(ctx, variant);
    }
    if (typeof TGLProduct.updatePrice === "function") {
      TGLProduct.updatePrice(ctx, variant);
    }
  }

  function initSection(section) {
    const data = TGLProduct.parseSectionData(section);
    if (!data || !Array.isArray(data.variants) || !data.variants.length) return;

    const ctx = {
      section,
      data,
      priceEl: section.querySelector("#productPrice"),
      variantIdInput: section.querySelector("#variant-id"),
      addToCartBtn: section.querySelector(".product-form .add-to-cart-btn"),
      stockIndicator: section.querySelector("#stockIndicator"),
      galleryThumbnails: section.querySelector(SELECTORS.galleryThumbnails),
      galleryIndicators: section.querySelector(SELECTORS.galleryIndicators),
      galleryMain: section.querySelector(SELECTORS.galleryMain),
      galleryPrev: section.querySelector(SELECTORS.galleryPrev),
      galleryNext: section.querySelector(SELECTORS.galleryNext),
      mainImage: section.querySelector(SELECTORS.mainImage),
      sizeButtons: Array.from(section.querySelectorAll(SELECTORS.sizeButton)),
      colorSwatches: Array.from(
        section.querySelectorAll(SELECTORS.colorSwatch)
      ),
      sizeGuideDetails: section.querySelector(SELECTORS.sizeGuideDetails),
      sizeGuideOpeners: section.querySelectorAll(SELECTORS.sizeGuideOpen),
    };

    if (typeof TGLProduct.ensureDefaultSelections === "function") {
      TGLProduct.ensureDefaultSelections(ctx);
    }
    if (typeof TGLProduct.applySizeLabels === "function") {
      TGLProduct.applySizeLabels(ctx);
    }
    if (typeof TGLProduct.updateOptionAvailability === "function") {
      TGLProduct.updateOptionAvailability(ctx);
    }
    if (typeof TGLProduct.bindGallery === "function") {
      TGLProduct.bindGallery(ctx);
    }
    if (typeof TGLProduct.bindSizeGuide === "function") {
      TGLProduct.bindSizeGuide(ctx);
    }
    if (typeof TGLProduct.bindOptions === "function") {
      TGLProduct.bindOptions(ctx);
    }

    const initialVariant =
      (typeof TGLProduct.findSelectedVariant === "function" &&
        TGLProduct.findSelectedVariant(ctx)) ||
      (typeof TGLProduct.findVariant === "function" &&
        TGLProduct.findVariant(
          data,
          (v) => String(v.id) === String(data.selectedVariantId)
        )) ||
      data.variants[0];

    applyVariant(ctx, initialVariant);
  }

  TGLProduct.applyVariant = applyVariant;
  TGLProduct.initSection = initSection;

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SELECTORS.productSection).forEach(initSection);
  });
})();
